import React from 'react';
import styles from '../index.module.scss';
import MeasurementBlock from './MeasurementBlock';
import SelectMeasurementUnitField from './SelectMeasurementUnitField';
import SurgeriesInformation from './SurgeriesInformation';
import FallBlock from './FallBlock';
import AmbulatoryField from './AmbulatoryField';
import AssistiveDeviceField from './AssistiveDeviceField';
import DiagnosisField from './DiagnosisField';
import OAndPFields from './OAndPFields';

const ClinicalInformation = () => {
  return (
    <div className={styles.sectionWrapper}>
      <span className={styles.sectionTitle}>Clinical Information</span>
      <div className={styles.filedsWrapper}>
        <SelectMeasurementUnitField />
        <MeasurementBlock />
        <DiagnosisField />
        <AssistiveDeviceField />
        <OAndPFields />
        <SurgeriesInformation />
        <AmbulatoryField />
        <FallBlock />
      </div>
    </div>
  );
};

export default ClinicalInformation;
